module.exports = __webpack_public_path__ + "img/Frame-94.26ca20a9.svg";